<pdq-card variant="flat" color="white">
  <div class="card-container">
    <div class="card-header">
      <div class="card-header__left">
        <pdq-heading element="h4">Preview</pdq-heading>
        <pdq-link
          size="small"
          label="Preview In Shopify"
          [clickable]="true"
          [external]="true"
          [url]="shopService.ecommerceEditorUrl()"></pdq-link>
      </div>
      <div class="card-header__right">
        <div class="device-switch">
          <button class="device-switch-desktop" (click)="mode.set('desktop')" [class.active]="mode() === 'desktop'">
            Desktop
          </button>
          <button class="device-switch__mobile" (click)="mode.set('mobile')" [class.active]="mode() === 'mobile'">
            Mobile
          </button>
        </div>
      </div>
    </div>

    <pdq-divider></pdq-divider>
    @if (mode() === 'desktop') {
      <div class="preview-content--desktop">
        <div class="preview-content--desktop__left">
          <ng-template [ngTemplateOutlet]="shippingDetails"></ng-template>
          @if (isAddressValidationEnabled()) {
            <address-validation-preview [isMobile]="false"></address-validation-preview>
          }
          @if (isOrderEditingDisplayed()) {
            <ng-template [ngTemplateOutlet]="orderEditing"></ng-template>
          }
        </div>
        <div class="preview-content--desktop__right">
          <ng-template [ngTemplateOutlet]="orderSummarySkeleton"></ng-template>
        </div>
      </div>
    } @else {
      <div class="preview-content--mobile">
        <mobile-frame>
          <div class="preview-content--mobile__content">
            <ng-template [ngTemplateOutlet]="shippingDetails"></ng-template>
            @if (isAddressValidationEnabled()) {
              <address-validation-preview [isMobile]="true"></address-validation-preview>
            }
            @if (isOrderEditingDisplayed()) {
              <ng-template [ngTemplateOutlet]="orderEditing"></ng-template>
            }
            <ng-template [ngTemplateOutlet]="orderSummarySkeleton"></ng-template>
          </div>
        </mobile-frame>
      </div>
    }
  </div>
</pdq-card>

<ng-template #orderSummarySkeleton>
  <div class="order-summary">
    <div class="order-summary-header">
      <div class="order-summary-row">
        <div class="order-summary-product">
          <div class="order-summary-product__left">
            <div class="skeleton__thumbnail"></div>
          </div>
          <div class="order-summary-product__right">
            <div class="skeleton__heading"></div>
            <div class="skeleton__text-row"></div>
          </div>
        </div>
        <div class="skeleton__heading" style="width: 30%"></div>
      </div>
    </div>
    <div class="order-summary-body">
      <div class="order-summary-row">
        <div class="skeleton__text-row" style="width: 30%"></div>
        <div class="skeleton__text-row__bold" style="width: 30%"></div>
      </div>
      <div class="order-summary-row">
        <div class="skeleton__text-row" style="width: 15%"></div>
        <div class="skeleton__text-row__bold" style="width: 15%"></div>
      </div>
      <div class="order-summary-row">
        <div class="skeleton__text-row" style="width: 110px"></div>
        <div class="skeleton__text-row__bold" style="width: 50%"></div>
      </div>
      <div class="order-summary-row" style="padding: 12px 0">
        <div class="skeleton__text-row__bold" style="width: 20%"></div>
        <div style="display: flex; gap: 4px; align-items: center">
          <div class="skeleton__text-row" style="width: 30%"></div>
          <div class="skeleton__text-row__bold" style="width: 30%"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #shippingDetails>
  <div class="shipping-details">
    <div class="shipping-details-header">
      <div class="shipping-details-header__left">
        <div class="skeleton__thumbnail"></div>
      </div>
      <div class="shipping-details-header__right">
        <div class="skeleton__text-row" style="width: 60%"></div>
        <div class="skeleton__heading" style="width: 70%"></div>
      </div>
    </div>
    <div class="shipping-details-body">
      <div class="skeleton__heading" style="width: 60%"></div>
      <div class="skeleton__text-row" style="width: 75%"></div>
      <div class="skeleton__text-row" style="width: 55%"></div>
      <div class="skeleton__text-row" style="width: 35%"></div>
      <div class="skeleton__text-row" style="width: 70%"></div>
      <div class="shipping-details-footer">
        <div class="skeleton__button"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #orderEditing>
  <div class="order-editing">
    <div class="order-editing__header" [class.mobile]="mode() === 'mobile'">
      <h5>Edit your order</h5>
      <p class="edit-window-end">You can make changes for the next 56:32</p>
    </div>
    <div class="order-editing__body">
      @if (template()?.edits?.customerDetails?.shippingAddress) {
        <div class="order-editing__body-block">
          <img src="assets/icons/shopify-icons/geolocation.svg" alt="geolocation" />
          <p>Edit Shipping Information</p>
          <pdq-icon icon="arrow_down" color="black"></pdq-icon>
        </div>
      }
      @if (template()?.edits?.product?.orderNote) {
        <div class="order-editing__body-block">
          <img src="assets/icons/shopify-icons/note.svg" alt="note" />
          <p>Order note</p>
          <pdq-icon icon="arrow_down" color="black"></pdq-icon>
        </div>
      }
      @if (template()?.edits?.product?.variant || template()?.edits?.product?.quantity) {
        <div class="order-editing__body-block">
          <img src="assets/icons/shopify-icons/bag.svg" alt="bag" />
          <p>Edit Products in Order</p>
          <pdq-icon icon="arrow_down" color="black"></pdq-icon>
        </div>
      }
      @if (template()?.edits?.product?.addProducts ?? template()?.edits?.product?.quantity) {
        <div class="order-editing__body-block">
          <img src="assets/icons/shopify-icons/cart.svg" alt="cart" />
          <p>Add Products</p>
          <pdq-icon icon="arrow_down" color="black"></pdq-icon>
        </div>
      }
      @if (isShippingMethodSelectionEnabled()) {
        <div class="order-editing__body-block">
          <i class="icon-shipping"></i>
          <p>Change Shipping method</p>
          <pdq-icon icon="arrow_down" color="black"></pdq-icon>
        </div>
      }
      @if (template()?.edits?.product?.discountCode) {
        <div class="order-editing__body-block">
          <i class="icon-discount"></i>
          <p>Apply Discount Code</p>
          <pdq-icon icon="arrow_down" color="black"></pdq-icon>
        </div>
      }
      @if (template()?.edits?.product?.cancelOrder) {
        <div class="order-editing__body-block" style="color: #1773b0; font-size: 10px; text-decoration: underline">
          Cancel Order
        </div>
      }
    </div>
  </div>
</ng-template>
